import { isRegExp as isRegExp$1 } from '../../predicate/isRegExp.mjs';

function isRegExp(value) {
    return isRegExp$1(value);
}

export { isRegExp };
